var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GenericTest',{attrs:{"test":_vm.test,"test_id":_vm.test_id,"answer":_vm.answer,"semester":_vm.semester,"previous_answer":_vm.previous_answer,"col_size":12,"label_size":8,"input_size":4,"no_margin":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }